import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { take } from 'rxjs/operators';
import { ErrorItem, ErrorTrackingService } from 'src/app/asistente-en-linea/services/error-tracking.service';
import { MailService } from '../../services/mail.service';
import { FormElements } from 'src/app/asistente-en-linea/models/FormElements';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import { MatDialog } from '@angular/material/dialog';
import { AlertaConsultenosComponent } from 'src/app/asistente-en-linea/basecomponents/alerta-consultenos/alerta-consultenos.component';
import { VentanaUtils } from 'src/app/asistente-en-linea/utils/ventana.utils';
import { RecaptchaService } from '../../../../services/recaptcha.service';
import { environment } from 'src/environments/environment';
import { ContextoUrlService } from '../../../../services/contexto-url.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { NavigationContextService } from '../../../../services/navigation-context.service';

declare const grecaptcha: any;
declare function eliminarUltimoEventoGoogleAnalytics();
declare function agregarEventoGoogleAnalytics(evento: any);

@Component({
  selector: 'app-formulario-persona',
  templateUrl: './formulario-persona.component.html',
  styleUrls: ['./formulario-persona.component.scss']
})
export class FormularioPersonaComponent implements OnInit {
  @Input() public ctx: Contexto;
  @Input() public formElements: FormElements;
  @Input() etiqueta_consulta: string = "";
  modificarDatosUrl: string;
  esAnonimo: boolean = true;
  esParaMi: boolean = true;
  habilitado: boolean = false;
  paraQuienEs: string = "";
  terminosAceptados: boolean = false;
  consulta: string;
  nombre: string;
  fromMenu: boolean = false;
  apellido: string;
  documento: string;
  tipoDocumento: string;
  departamento: string;
  localidad: string;
  correo: string;
  persIdentificador: string = "";
  consulta_error_mensaje: string = "";
  nombre_error_mensaje: string = "";
  apellido_error_mensaje: string = "";
  documento_error_mensaje: string = "";
  tipo_documento_error_mensaje: string = "";
  localidad_error_mensaje: string = "";
  correo_error_mensaje: string = "";
  terminos_error: string = "";
  mensajeError: string = "";
  opcionesTipoDocumento: { value: string, texto: string }[] = [];
  opcionesParaQuienEs: { value: string, texto: string }[] = [];
  opcionesDepartamento: { value: string, texto: string }[] = [];
  correos: string[] = [];
  errores: ErrorItem[] = [];
  attachments: any[];
  // codigoTema = el tema que selecciona el usuario en el formulario
  codigoTema: string;
  descripcionTema: string; //corresponde al código del tema destinatario
  etiquetaNodoArbol: string;
  caracteres_maximo_consulta: number = 600;
  onSubmitProcess: boolean = false;
  onSuccess: boolean = false;
  // temasAsociados = temas disponibles para un servicio dado (se visualiza como lista de seleccion)
  temasAsociados: any[] = [];

  onError: boolean = false;
  cargandoDatos: boolean = true;

  // Datos de la persona obtenidos por service para usar en "Para mi"
  nombrePersona: string;
  documentoPersona: string;
  tipoDocumentoPersona: string;
  telefonoPersona: string;
  codigoPaisEmisorPersona: string;
  // Emitter usado para volver al Handler desde donde se invoco este formulario
  @Output() switchHandlerEmitter = new EventEmitter<Object>();

  recaptcha = false;
  showV2Captcha = false;
  captchaV2Token: string = "";
  captchaV3Token: string = "";
  sitePublicKeyV2: string = "";
  sitePublicKeyV3: string = "";
  errorValidacion: boolean = false;
  constructor(public errorTrackingService: ErrorTrackingService,
    private recaptchaSrv: RecaptchaService,
    private contextoService: ContextoUrlService,
    private navigationContextService: NavigationContextService,
    public rest: MailService,
    public dialog: MatDialog,
    public window: VentanaUtils
  ) {
    this.errorTrackingService.setErrors([]);
    this.fromMenu = false;

    this.recaptcha = false;
    this.showV2Captcha = false;
  }

  ngOnInit() {
    this.opcionesTipoDocumento = [{ value: "DO", texto: "Cédula" }, { value: "P", texto: "Pasaporte" }, { value: "F", texto: "Fronterizo" }]
    this.opcionesParaQuienEs = [{ value: "parami", texto: "Para mi" }, { value: "paraotra", texto: "Para otra persona" }]
    this.paraQuienEs = "parami";
    this.etiqueta_consulta = this.ctx.etiquetaTema;
    this.modificarDatosUrl = this.ctx.modificarDatosUrl;

    this.recaptcha = this.captchaActivo();

    this.sitePublicKeyV2 = this.ctx.clavePublicaV2;
    this.sitePublicKeyV3 = this.ctx.clavePublicaV3;

    this.cargarInformacion();
  }


  captchaActivo(): boolean {
    return this.ctx.esEntornoAnonimo && this.ctx.captchaHabilitado;
  }

  actualizarTipoDocumento(tipoDocumento: string) {
    this.tipoDocumento = tipoDocumento;
  }

  actualizarParaQuienEs() {
    this.esParaMi = this.paraQuienEs == "parami";
    this.limpiarErrores();
    this.limpiarValores();
  }

  nuevoEmail(correo: string) {
    this.correos.push(correo);
  }

  eliminarMail(correo: string) {
    this.correos = this.correos.filter(c => c != correo);
  }

  actualizarDepartamento(departamento: string) {
    this.departamento = departamento;
  }

  actualizarAdjuntos(adjuntos: any[]) {
    this.attachments = adjuntos;
  }

  /**
  * Retorna al handler desde el cual fue llamado el formulario
  */
  switchAssistantHandler() {
    eliminarUltimoEventoGoogleAnalytics();
    this.ctx.codAsistenteError = undefined;
    this.ctx.esReporteError = false;
    this.recaptchaSrv.limpiarRecaptchaV3();
    if (this.ctx.fromAnonymous) {
      this.window.close.emit();
      if (window.opener) {
        window.opener.postMessage({ accion: 'cerrarPopup' }, '*');
      }
    } else {
      this.ctx.idNodo = undefined;
      this.ctx.codAsistenteError = undefined;
      this.ctx.idMenu = this.ctx.historialMenus[0];
      this.ctx.historialMenus = [];
      this.ctx.codAsistente = this.ctx.codAsistenteOriginal;
      // almacena informacion de navegacion
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
      this.navigationContextService.clearAll();
      this.switchHandlerEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistenteOriginal, idMenu: this.ctx.idMenu });
    }
  }

  private esCorreoValido(correo: string): boolean {
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regexEmail.test(correo);
  }



  realizarValidaciones() {

    this.limpiarErrores();

    if (
      this.captchaActivo() &&
      this.showV2Captcha &&
      !this.captchaV2Token
    ) {
      this.errorValidacion = true;
      this.mensajeError = "Por favor marque la casilla 'No soy un robot'";
      return true;
    }

    // Validación de nombre
    const tamanioNombre = this.nombre ? this.nombre.length : 0;
    let nombre_valido = tamanioNombre > 0;
    if (!nombre_valido) {
      this.nombre_error_mensaje = "El nombre no puede estar vacío.";
      this.errores.push({ mensaje: this.nombre_error_mensaje, field: "nombre" });
    }

    const tamanioTipoDoc = this.tipoDocumento ? this.tipoDocumento.length : 0;
    let tipo_doc_valido = tamanioTipoDoc > 0;
    if (!tipo_doc_valido) {
      this.tipo_documento_error_mensaje = "El tipo de documento no puede estar vacío.";
      this.errores.push({ mensaje: this.tipo_documento_error_mensaje, field: "tipoDocumento" });
    }
    //this.ctx.esEntornoAnonimo =false;
    // Validación de documento
    let documento_valido = false;
    const tamanioDocumento = this.documento ? this.documento.length : 0;
    if (tamanioDocumento > 0) {
      if (tipo_doc_valido && this.tipoDocumento == 'DO') {
        if (this.ctx.esEntornoAnonimo || (!this.ctx.esEntornoAnonimo && this.codigoPaisEmisorPersona && this.codigoPaisEmisorPersona === '1')) {
          documento_valido = this.validarCedula(this.documento);
          if (!documento_valido) {
            this.documento_error_mensaje = "El documento ingresado no es válido.";
            this.errores.push({ mensaje: this.documento_error_mensaje, field: "documento" });
          }
        }
      }
    } else {
      this.documento_error_mensaje = "El número de documento no puede estar vacío.";
      this.errores.push({ mensaje: this.documento_error_mensaje, field: "documento" });
    }

    /* ========= CORREO ========= */
    if (!this.correo || this.correo.trim().length === 0) {
      this.correo_error_mensaje = 'El correo electrónico no puede estar vacío.';
      this.errores.push({ mensaje: this.correo_error_mensaje, field: 'correo' });
    } else if (!this.esCorreoValido(this.correo)) {
      this.correo_error_mensaje = 'El formato del correo electrónico no es válido.';
      this.errores.push({ mensaje: this.correo_error_mensaje, field: 'correo' });
    }
    const tamanioConsulta = this.consulta ? this.consulta.length : 0;
    // Validación de consulta
    let consulta_valida = tamanioConsulta > 0;
    if (!consulta_valida) {
      this.consulta_error_mensaje = "La consulta no puede estar vacía.";
      this.errores.push({ mensaje: this.consulta_error_mensaje, field: "consulta" });
    }

    if (this.caracteres_maximo_consulta < tamanioConsulta) {
      this.consulta_error_mensaje = "La consulta no puede superar el límite (" + this.caracteres_maximo_consulta + ") de caracteres";
      this.errores.push({ mensaje: this.consulta_error_mensaje, field: "consulta" });
    }
    this.asignarErrores();

    return this.errores.length > 0;
  }

  asignarErrores() {
    this.errorTrackingService.setErrors(this.errores);
    // if (this.errores.length > 0) {
    //   setTimeout(() => {
    //     this.focoElemento("existe-error");
    //   }, 500)
    // }
  }

  validarDocumento() {
    this.documento_error_mensaje = "";
    if (this.documento == "") return;
    let documento_valido = this.documento && this.validarCedula(this.documento);
    if (!this.esParaMi && !documento_valido) {
      this.documento_error_mensaje = "El documento ingresado no es válido.";
    }
  }

  limpiarErrores() {
    this.errores = [];
    this.errorValidacion = false;
    this.errorTrackingService.setErrors([]);
    this.consulta_error_mensaje = "";
    this.nombre_error_mensaje = "";
    this.apellido_error_mensaje = "";
    this.documento_error_mensaje = "";
    this.tipo_documento_error_mensaje = "";
    this.localidad_error_mensaje = "";
    this.correo_error_mensaje = "";
    this.terminos_error = "";
    this.mensajeError = "";
  }

  limpiarValores() {
    if (this.esAnonimo) {
      this.nombre = "";
      this.apellido = "";
      this.documento = "";
      this.tipoDocumento = "";
      this.correo = "";
    }
    this.consulta = "";
    this.departamento = "";
    this.localidad = "";
    this.terminosAceptados = false;
  }


  validarCedula(ci) {
    ci = ci.replace(/\D/g, '');
    var dig = ci[ci.length - 1];
    ci = ci.replace(/[0-9]$/, '');
    return (dig == this.validarDigitoCedula(ci));
  }

  validarDigitoCedula(ci) {
    var a = 0;
    var i = 0;
    if (ci.length <= 6) {
      for (i = ci.length; i < 7; i++) {
        ci = '0' + ci;
      }
    }
    for (i = 0; i < 7; i++) {
      a += (parseInt("2987634"[i]) * parseInt(ci[i])) % 10;
    }
    if (a % 10 === 0) {
      return 0;
    } else {
      return 10 - a % 10;
    }
  }

  focoElemento(elementoId: string) {

    const element = document.getElementById(elementoId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  async nuevaConsulta() {
    this.ctx.codAsistenteError = undefined;
    this.ctx.esReporteError = false;
    this.errorValidacion = false;
    this.consulta = "";
    this.paraQuienEs = "parami";
    this.actualizarParaQuienEs();
    this.limpiarValores();
    //this.cargarInformacion();
    this.onSuccess = false;

  }

  async realizarConsulta() {

    if (this.realizarValidaciones()) {
      return;
    }

    let formData: FormData = new FormData();
    await this.cargarTokenCaptcha(formData);
    // Cargo todos los adjuntos al form data
    this.cargarAdjuntos(formData);

    // Cargo toda la información personal al form data
    this.cargarInformacionPersonal(formData);

    // Cargo la información de la consulta al form data
    this.cargarInformacionGeneral(formData);
    this.onSubmitProcess = true;
    /** 
    formData.forEach((value, key) => {
      console.log(key, value);
    });
    this.onSubmitProcess = false;
    return;
    **/
    this.rest.submitEmailFormWithAttachments(formData).subscribe({
      next: async (response) => {
        const captchaRequeridoPeroInvalido = this.captchaActivo() && !response.recaptchaValido;

        if (captchaRequeridoPeroInvalido) {
          this.onSuccess = true;
          this.onSubmitProcess = false;
          this.showV2Captcha = true;
          this.errorValidacion = true;
          this.mensajeError = "Por favor marque la casilla 'No soy un robot'";
          this.captchaV2Token = await this.recaptchaSrv.generarTokenCaptchaV2(
            this.sitePublicKeyV2,
            'recaptcha-container'
          );
          return;
        }

        this.ingresoConsultaOk();
      },
      error: (error) => {
        this.onSubmitProcess = false;
        console.error('Error al enviar formulario', error);
        this.mensajeError = 'En este momento no podemos atenderlo debido a que estamos experimentando algunos problemas técnicos; por favor intente comunicarse con nosotros más tarde.';
        this.errorValidacion = true;
      }
    });


  }

  cargarInformacionPersonal(formData: FormData) {
    if (this.esAnonimo) {
      this.cargarInformacionAnonimo(formData);
    } else {
      this.cargarInformacionAutenticado(formData);
    }
  }

  async cargarTokenCaptcha(formData: FormData) {

    if (!this.captchaActivo()) {
      formData.append("validarRecaptcha", "false");
      return;
    }

    formData.append("validarRecaptcha", "true");

    if (this.showV2Captcha) {
      formData.append("tokenRecaptcha", this.captchaV2Token);
      formData.append("versionRecaptcha", "V2");
    } else {
      this.captchaV3Token =
        await this.recaptchaSrv.generarTokenCaptchaV3(
          this.sitePublicKeyV3,
          'importantAction'
        );

      formData.append("tokenRecaptcha", this.captchaV3Token);
      formData.append("versionRecaptcha", "V3");
    }
  }
  cargarInformacionAutenticado(formData: FormData) {
    if (this.nombrePersona) {
      formData.append("nombreCompleto", this.patchEncoding(this.nombrePersona));
    }
    if (this.documentoPersona) {
      formData.append("documento", this.documento);
    }
    if (this.tipoDocumentoPersona) {
      formData.append("tipoDocumento", this.tipoDocumentoPersona);
    }
    if (this.telefonoPersona) {
      formData.append("telefono", this.telefonoPersona);
    }
    if (this.codigoPaisEmisorPersona==undefined && this.tipoDocumento != undefined && this.tipoDocumento == 'DO') {
      this.codigoPaisEmisorPersona= '1';
    }
    
    if (this.codigoPaisEmisorPersona) {
      formData.append("codigoPaisEmisor", this.codigoPaisEmisorPersona);
    }
    if (this.tipoDocumentoPersona) {
      formData.append("tipoDocumento", this.tipoDocumentoPersona);
    }

    if (this.persIdentificador) {
      formData.append("persIdentificadorStr", this.persIdentificador);
    }

    //Ver aqui si debe enviarse el maily si deben ser todos los de la lista
    if (this.correos.length > 0) {
      formData.append("email", this.correos[0]);
    }

  }

  cargarInformacionAnonimo(formData: FormData) {
    if (this.nombre) {
      formData.append("nombreCompleto", this.patchEncoding(this.nombre));
    }
    if (this.documento) {
      formData.append("documento", this.documento);
    }
    if (this.tipoDocumento) {
      formData.append("tipoDocumento", this.tipoDocumento);
    }

    if (this.codigoPaisEmisorPersona==undefined && this.tipoDocumento != undefined && this.tipoDocumento == 'DO') {
      this.codigoPaisEmisorPersona= '1';
    }
    if (this.codigoPaisEmisorPersona) {
      formData.append("codigoPaisEmisor", this.codigoPaisEmisorPersona);
    }
    
    formData.append("email", this.correo);
  }

  cargarInformacionGeneral(formData: FormData) {
    formData.append("mensaje", this.patchEncoding(this.consulta));
    if (this.ctx.idServicio) {
      formData.append("idServicio", this.ctx.idServicio);
    }
    if (this.ctx.codAsistente) {
      formData.append("codAsistente", this.ctx.codAsistente);
    }
    if (this.ctx.codAsistenteError) {
      formData.append("codAsistenteError", this.ctx.codAsistenteError);
    }

    if (this.ctx.contexto) {
      formData.append("contexto", this.contextoService.decode(this.ctx.contexto));
    } else {
      formData.append("contexto", this.contextoService.getParentUrlSafely());
    }


    if (this.codigoTema) {
      formData.append("codigoTema", this.codigoTema);
    }
    if (this.descripcionTema) {
      formData.append("descripcionTema", this.patchEncoding(this.descripcionTema));
    }
    if (this.ctx.codigoNodoArbol || this.ctx.idNodo) {
      formData.append("idNodo", this.ctx.idNodo ? this.ctx.idNodo : this.ctx.codigoNodoArbol);
    }
    if (this.etiquetaNodoArbol) {
      formData.append("descripcionNodo", this.patchEncoding(this.etiquetaNodoArbol));
    }
    if (this.ctx.idMenu) {
      formData.append("idArbol", this.ctx.idMenu);
    }
    if (this.ctx.idFormAsociado) {
      formData.append("idFormAsociado", this.ctx.idFormAsociado);
    }
    // TODO: HARDCODED PARA QUE GUARDE DATOS MIENTRAS NO DEJEMOS FUNCIONANDO EL CATPCHA 
    //formData.append("validarCaptcha", "false");
    //formData.append("ValidarRecaptcha", "false");
    formData.append( "validarRecaptcha", this.captchaActivo() ? "true" : "false");

    const ids = this.navigationContextService.getIds() || [];
    if(ids.length > 0) {
      formData.append("historicoNodos", ids.join(','));
    }
  }

  cargarAdjuntos(formData: FormData) {
    if (!this.attachments || this.attachments.length === 0) {
      return;
    }

    let i = 1;
    for (const att of this.attachments) {
      if (i > 4) {
        break;
      }

      formData.append(`adjunto${i}`, att);
      formData.append("nombreAdjunto" + i, this.patchEncoding(att.name));
      i++;
    }
  }


  ingresoConsultaOk() {
    this.ctx.idNodo = undefined;
    this.onSuccess = true;
    this.onSubmitProcess = false;
    const dialogRef = this.dialog.open(AlertaConsultenosComponent, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.ctx.codAsistenteError = undefined;
      if (result === AlertaConsultenosComponent.nueva_consulta) {
        this.nuevaConsulta();
      }
      else if (result === AlertaConsultenosComponent.cerrar_asistente) {
        if (this.ctx.refresh) {
          this.nuevaConsulta();
          this.switchAssistantHandler();
        } else {
          // this.recaptchaSrv.limpiarRecaptchaV3();
          this.window.close.emit();
          if (window.opener) {
            window.opener.postMessage({ accion: 'cerrarPopup' }, '*');
          }
        }
      }
    })
  }

  /**
  * Metodo auxiliar que convierte algunos caracteres especiales por limintacion actual 
  * que tenemos para enviar datos 
  * @param valor 
  * @returns 
  */
  private patchEncoding(valor: string): string {
    if (valor) {
      let resultado = valor.replace(/ñ/g, '&ntilde;').replace(/Ñ/g, '&Ntilde;');
      resultado = resultado.replace(/á/g, '&aacute;').replace(/Á/g, '&Aacute;');
      resultado = resultado.replace(/é/g, '&eacute;').replace(/É/g, '&Eacute;');
      resultado = resultado.replace(/í/g, '&iacute;').replace(/Í/g, '&Iacute;');
      resultado = resultado.replace(/ó/g, '&oacute;').replace(/Ó/g, '&Oacute;');
      resultado = resultado.replace(/ú/g, '&uacute;').replace(/Ú/g, '&Uacute;');
      resultado = resultado.replace(/ü/g, '&uuml;').replace(/Ü/g, '&Uuml;');
      resultado = resultado.replace(/¿/g, '&iquest;');
      resultado = resultado.replace(/!/g, '&#33;');
      resultado = resultado.replace(/¡/g, '&#161;');
      return resultado;

    } else {
      return valor
    }
  }
  
  async intentarInicializarSesion() {
    //this.ctx.esEntornoAnonimo=false;
    if (!this.ctx.esEntornoAnonimo && this.ctx.fromAnonymous) {
      let url = new URL(this.ctx.urlSitioAutenticar).origin + "/PortalServLinea/rest/inicio/cargarInfoUsuario";
      try {
        const response = await this.rest.obtenerSesionUsuario(url).pipe(take(1)).toPromise();
        console.log(response);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    }
    return true;
  }

  mostrarBotonVolverInicio() {
    if (Object.keys(this.ctx.navigationHistory).length != 0) {
      this.fromMenu = true;
    }
    if (this.ctx.fromAnonymous) {
      this.fromMenu = true;
    }

    if (!this.fromMenu) {
      const asistenteAnterior = this.ctx.obtenerMenuActual();
      if (asistenteAnterior && asistenteAnterior != undefined && asistenteAnterior != '' ) {
        this.fromMenu = true;
      }
    }
  }

  async cargarInformacion() {
    //this.tipoDocumento = "DO";
    this.habilitado = false;
    this.etiqueta_consulta = this.ctx.etiquetaTema;
    this.cargandoDatos = true;

    const request = {
      idAsistente: this.ctx.idAsistente,
      idNodo: this.ctx.idNodo ? this.ctx.idNodo : this.ctx.codigoNodoArbol,
      codAsistenteError: this.ctx.codAsistenteError
    }
    this.codigoTema = this.ctx.codigoTema;

    const correcto = await this.intentarInicializarSesion();
    if (correcto) {
      this.rest.cargaDatosPersonales(request).subscribe((response) => {
        this.habilitado = response.habilitado;
        if (this.habilitado) {
          this.esAnonimo = typeof response.context.userName == 'undefined';
          this.etiqueta_consulta = response.nombreFormulario;
          if (this.recaptcha) {
            this.showRecaptchaV3();
          }

          this.mostrarBotonVolverInicio();

          this.ctx.datosEmpresa = response.context.datosEmpresa;
          this.ctx.datosPersonales = response.context.datosPersonales;
          this.persIdentificador = response.context.persIdentificadorStr;

          if (this.ctx.datosPersonales) {
            if (this.ctx.datosPersonales.email) {
              this.correos.push(this.ctx.datosPersonales.email);
            }
            this.tipoDocumento = this.ctx.datosPersonales.tipoDocumento;
            if (this.tipoDocumento == undefined) {
              this.tipoDocumento = "DO";
            }
            this.telefonoPersona = this.ctx.datosPersonales.telefono;
            this.nombrePersona = this.ctx.datosPersonales.nombreCompleto;
            this.documentoPersona = this.ctx.datosPersonales.documento;
            this.documento = this.documentoPersona;
            this.tipoDocumentoPersona = this.ctx.datosPersonales.tipoDocumento;
            this.codigoPaisEmisorPersona = this.ctx.datosPersonales.codigoPaisEmisor;

            this.correo = this.ctx.datosPersonales.email;
          }


          this.temasAsociados = response.context.temasAsociados;

          this.nombre = this.nombrePersona;

          //this.ctx.codigoTema ='1';
          // Se comprueba si se produce una inyeccion del 'codigoTema' en la URL
          if (this.ctx && this.ctx.codigoTema) {
            // Si el tema viene dado por parametro se instancia ese
            this.codigoTema = this.ctx.codigoTema;
            this.descripcionTema = this.ctx.etiquetaTema;
            //this.etiquetaNodoArbol = this.ctx.etiquetaNodoArbol;

            // si en el contexto tiene cargado etiqueaNodoArbol es porque viene de menu, sino debe tener inyectado codigoTema en URL
            if (this.ctx.etiquetaNodoArbol) {
              this.etiquetaNodoArbol = this.ctx.etiquetaNodoArbol;
            } else {
              for (let t of this.temasAsociados) {
                if (t.codigo == this.codigoTema) {
                  this.descripcionTema = t.titulo;
                  this.etiquetaNodoArbol = t.titulo;
                  break;
                }
              }
            }
          }
        }
        this.ctx.etiquetaTema = response.nombreFormulario;
        this.cargandoDatos = false;
        // Eventos para google analytics
        this.registrarEvento();
      }, (err) => {
        console.log(err);
        this.onError = true;
        this.cargandoDatos = false;
      });
    } else {
      this.onError = true;
      this.cargandoDatos = false;
    }
  }

  async showRecaptchaV3() {
    if (!this.captchaActivo()) {
      return;
    }

    await this.recaptchaSrv.executeRecaptchaV3(
      this.sitePublicKeyV3,
      'homepage'
    );
  }

  registrarEvento() {
    let evento = {
      codAsistente: this.ctx.codAsistente,
      descServicio: this.ctx.descServicio,
      idAsistente: this.ctx.idAsistente,
      idServicio: this.ctx.idServicio,
      idNodo: this.ctx.idNodo,
      nodoNombre: this.ctx.etiquetaTema
    }
    agregarEventoGoogleAnalytics(evento);
  }

}